<template>
  <select
    :value="value"
    v-on="{
      ...$listeners,
      input: event => $emit('input', event.target.value),
      change: event => $emit('input', event.target.value)
    }"
  >
    <option v-if="allowEmpty" value="">
      {{ emptyText }}
    </option>
    <option value="-5.0">
      Eastern Time
    </option>
    <option value="-6.0">
      Central Time
    </option>
    <option value="-7.0">
      Mountain Time
    </option>
    <option value="-8.0">
      Pacific Time
    </option>
    <option value="-9.0">
      Alaska Time
    </option>
    <option value="-10.0">
      Hawaii Time
    </option>
  </select>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        required: true
      },
      allowEmpty: {
        type: Boolean,
        default: false
      },
      emptyText: {
        type: String,
        default: ""
      }
    },
    created() {
      // if not allow empty, and value is empty, default to -5.0
      if (!this.allowEmpty && !this.value) {
        this.$emit('input', '-5.0');
      }
    }
  }
</script>
